import { render, staticRenderFns } from "./DocumentsLast.vue?vue&type=template&id=2479a5c9&"
import script from "./DocumentsLast.vue?vue&type=script&lang=js&"
export * from "./DocumentsLast.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports